module.exports = __webpack_public_path__ + "img/host_brand.b176fc7c.svg";